import { withTranslation } from "react-i18next";
import TourTicket from './TourTicket';

export default withTranslation()(TourTicket);